import AppContext from '../contexts/AppContext';
import DataContext from '../contexts/DataContext';
import EnphaseContext from '../contexts/EnphaseContext';
import ConfigContext from '../contexts/ConfigContext';
import { useContext, useState, useEffect, useRef } from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import Button from './Button';
import { isMobile } from './../helpers';

const DEFAULT_ELEC_BILL = 250;

export default function BillSlider() {
  const {
    slides,
    currentSlide,
    goToNextSlide,
    geoData,
    updateSelectedOption,
    getSlideIndex,
    hasElecBillChanged,
    setHasElecBillChanged,
  } = useContext(AppContext);
  const { data, updateData } = useContext(DataContext);
  const { getInitialEnphaseData } = useContext(EnphaseContext);
  const configData = useContext(ConfigContext);
  const { features } = configData;
  const defaultBillValue = features.useElecBillByState
    ? hasElecBillChanged
      ? data.bill
      : data.elecBillByState
    : slides[currentSlide].selectedValue || DEFAULT_ELEC_BILL;
  const [value, setValue] = useState(defaultBillValue);

  useEffect(() => {
    slides[currentSlide].selectedValue = value;
    updateData({ ...data, bill: value });
  }, [value]);

  const sliderRef: any = useRef(null);

  useEffect(() => {
    const addressSlideNumber = getSlideIndex('addressOwnership');

    if (
      geoData?.zip &&
      !slides[addressSlideNumber].additionalFields?.selectedZipCode
    ) {
      updateSelectedOption(
        slides[addressSlideNumber].key,
        geoData.zip || '',
        'selectedZipCode'
      );
    }

    getInitialEnphaseData();

    if (features.showLanderConcept && isMobile()) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      const rail = sliderRef.current?.querySelectorAll(
        '.rc-slider.rc-slider-horizontal'
      )[0];
      // rail.setAttribute('data-zuko-tag-name', 'BUTTON');
      // rail.setAttribute('data-zuko-id', 'electricity-bill-slider-rail');

      const handle =
        sliderRef.current?.querySelectorAll('.rc-slider-handle')[0];
      // handle.setAttribute('data-zuko-tag-name', 'BUTTON');
      // handle.setAttribute('data-zuko-id', 'electricity-bill-slider-handle');
    }
  }, [sliderRef]);

  return (
    <div className="select-none">
      <div className="mt-[90px] md:mt-[125px] flex justify-between flex-col md:flex-row">
        <div
          className="max-w-[279px] md:w-[400px] md:max-w-none relative"
          ref={sliderRef}>
          <Slider
            value={value}
            min={50}
            max={850}
            onChange={(value) => {
              setHasElecBillChanged(true);
              setValue(value);
            }}
            step={25}
          />
          <SliderTooltip value={value} />
        </div>
      </div>
      <div className="mt-[50px] md:mt-20">
        <Button
          title="Continue"
          action={() => {
            dataLayer.push({
              event: 'seform_monthly_electricity_bill',
              event_action: 'How much is your monthly electricity bill?',
              event_label: value,
            });
            goToNextSlide();
          }}
        />
      </div>
    </div>
  );
}

const SliderTooltip = function ({ value }: any) {
  const leftPosition = (value / 800) * 100 + '%';
  return (
    <div
      className="absolute text-[15px] short:!text-[14px] md:text-base text-white bg-[#3C3C3C] p-3 rounded min-w-[50px] md:min-w-[64px] text-center mt-[-75px] short:!mt-[-75px] md:mt-[-90px] ml-[-47px] short:!ml-[-43px] md:ml-[-57px]"
      style={{
        left: leftPosition,
        lineHeight: 1,
      }}>
      {`$${value}`}
      <span className="arrow-down"></span>
    </div>
  );
};

export const getElecBillByState = (state: string): number => {
  const elecBillByStateMap = {
    CA: 218,
    TX: 185,
    FL: 259,
    CT: 273,
    IL: 139,
    NJ: 153,
    MA: 220,
    AZ: 180,
    GA: 171,
    OH: 165,
    CO: 120,
    PA: 202,
    MD: 192,
    OK: 204,
    NV: 191,
    VA: 182,
    AR: 202,
  };

  if (elecBillByStateMap.hasOwnProperty(state)) {
    return (elecBillByStateMap as any)[state];
  } else {
    return DEFAULT_ELEC_BILL;
  }
};
